export default "__VITE_ASSET__CiVi2X3b__"